
export function playClickSound() {
    const sound = document.getElementById("clickSound");

    if (sound) {    
        sound.setAttribute('sound', 'volume: 1')   
        sound.components['sound'].playSound();
    }
}
     